import ApiCalls from "../util/ApiCalls";

class ContactFormService {
    async create(contactFormDto) {
        return ApiCalls.defaultPost("/contact-form", {}, contactFormDto);
    }
}

export default new ContactFormService();